import * as React from 'react';
import { useTranslation } from 'react-i18next';

function AssessmentRiskLevelChart(props) {
  const { t } = useTranslation();
  const riskLevel = props.riskLevel;

  const text = {
    fontSize: 12,
    fontFamily: 'Museo-500',
    fill: '#596f86',
  };

  const renderTextLabels = () => {
    return (
      <React.Fragment>
        <text
          transform="translate(310.6 10.68)"
          className="prefix__st1 prefix__st2"
          fill="#30383f"
          style={text}
        >
          {''}
        </text>
        <text
          transform="translate(301.8 93.63)"
          className="prefix__st3 prefix__st1 prefix__st2"
          id="prefix__prefix_High"
          style={text}
        >
          {'High'}
        </text>
        <text
          transform="translate(139.94 93.63)"
          className="prefix__st3 prefix__st1 prefix__st2"
          id="prefix__prefix_Moderate"
          style={text}
        >
          {'Moderate'}
        </text>
        <text
          transform="translate(3.8 93.63)"
          className="prefix__st3 prefix__st1 prefix__st2"
          id="prefix__prefix_Low"
          style={text}
        >
          {'Low'}
        </text>
      </React.Fragment>
    );
  };

  const renderLowRiskVariant = () => {
    return (
      <React.Fragment>
        <linearGradient
          id="prefix__SVGID_1_"
          gradientUnits="userSpaceOnUse"
          x1={-51.23}
          y1={65.585}
          x2={-50.73}
          y2={65.585}
        >
          <stop offset={0.009} stopColor="#9ac435" />
          <stop offset={1} stopColor="#8fbf21" />
        </linearGradient>
        <path
          d="M3.8 71.8v8.4h108.4V50.9L8.6 66.2c-2.7.4-4.8 2.8-4.8 5.6z"
          fill="url(#prefix__SVGID_1_)"
        />
        <path
          d="M220.6 34.9l-108.4 16v29.3H329V25.4c0-3.5-3.1-6.1-6.5-5.6L220.6 34.9z"
          fill="#d7dfe6"
        />
      </React.Fragment>
    );
  };
  const renderMediumRiskVariant = () => {
    return (
      <React.Fragment>
        <path
          d="M112.2 51.3L8.6 66.7c-2.8.4-4.8 2.8-4.8 5.6v8.4h216.8V35.3l-108.4 16z"
          fill="#ffac1a"
        />
        <path
          d="M220.6 80.7H329V25.8c0-3.5-3.1-6.1-6.5-5.6L220.6 35.3v45.4z"
          fill="#d7dfe6"
        />
      </React.Fragment>
    );
  };
  const renderHighRiskVariant = () => {
    return (
      <path
        d="M3.8 69.3v8.4H329V22.8c0-3.5-3.1-6.1-6.5-5.6L8.6 63.7c-2.7.4-4.8 2.7-4.8 5.6z"
        fill="#f26914"
      />
    );
  };

  return (
    <svg
      id="prefix__Layer_1"
      x={0}
      y={0}
      viewBox="0 0 333 99.5"
      xmlSpace="preserve"
      {...props}
    >
      <title>{'Artboard 1 copy 2'}</title>
      <g id="prefix__prefix_Graph_Assessment">
        {props.showLabels && renderTextLabels()}
        {riskLevel === 0 && renderLowRiskVariant()}
        {riskLevel === 1 && renderMediumRiskVariant()}
        {riskLevel === 2 && renderHighRiskVariant()}
      </g>
    </svg>
  );
}

export default AssessmentRiskLevelChart;
